module.exports = __webpack_public_path__ + "img/02.d2ac2f85.png";